import React, { useEffect } from "react";
import Fields from "./FormFields";
import { useTheme } from "@mui/material/styles";
import { Form as FormikForm, useFormikContext } from "formik";
import { PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
const Form = ({ error, formFields, formSpacing = 1.5, submitText, errorText, disabled }) => {
    const theme = useTheme();
    const { resetForm } = useFormikContext();
    useEffect(() => {
        if (error) {
            resetForm();
        }
    }, [error]);
    return (React.createElement(FormikForm, null,
        React.createElement(PeekStack, { direction: "column", spacing: formSpacing },
            React.createElement(Fields, { fields: formFields }),
            React.createElement(PeekStack, { direction: "column", alignItems: "center", spacing: 1 },
                error && (React.createElement(PeekTypography, { variant: "body1", color: "error" }, errorText || error.message)),
                submitText && (React.createElement(PeekButton, { fullWidth: true, size: "large", type: "submit", variant: "contained", disabled: disabled, sx: {
                        mt: 0,
                        backgroundColor: `${theme.palette.primary.main}`,
                        ":hover": {
                            backgroundColor: `${theme.palette.primary.main}`,
                        },
                    } }, submitText))))));
};
export default Form;
